/**
 * Global QR code component - never shown on mobile devices
 * Desktop: Hidden (QR icon is in navigation)
 * Mobile: Never shown
 *
 * Props
 *   • size – square size in px (default 160)
 *   • ...rest – any extra props for react‑qr‑code (fgColor, bgColor, level, …)
 */
export default function GlobalQR({ size = 160, ...rest }) {
  // Never show GlobalQR on any device
  return null;
}
